module.exports = __webpack_public_path__ + "static/media/101010-house-of-yes-dance-party.047f923c.mp4";